import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import { registerUser, apiError } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
	Row,
	Col,
	CardBody,
	Card,
	Alert,
	Container,
	Input,
	Label,
	Form,
	FormFeedback,
	Button,
} from "reactstrap";
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import userService from "services/UserService";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const NovaSenha = ({ email, toggle }) => {
	const dispatch = useDispatch();
	const [showPasswordFields, setShowPasswordFields] = useState(false); // State to handle showing password fields or verification code field
	const [loadingVerify, setLoadingVerify] = useState(false); // State to handle loading state of the verify button
	const [loadingSubmit, setLoadingSubmit] = useState(false); // State to handle loading state of the submit button

	const verificationSchema = Yup.object({
		email: Yup.string().required("Por favor, informe seu email"),
		verification_code: Yup.string().required(
			"Por favor, informe o código de verificação",
		),
	});

	const passwordSchema = Yup.object({
		new_password: Yup.string().required(
			"Por favor, informe sua nova senha",
		),
		confirm_password: Yup.string()
			.required("Por favor, confirme sua nova senha")
			.oneOf([Yup.ref("new_password")], "As senhas não conferem"),
	});

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: email,
			verification_code: "", // Added verification_code field to the initial values
			new_password: "",
			confirm_password: "",
		},
		validationSchema: showPasswordFields
			? passwordSchema
			: verificationSchema,
		onSubmit: async (values) => {
			try {
				if (!showPasswordFields) {
					setLoadingVerify(true); // Set loading state to true to show spinner on verify button
					const response = await userService.verifyVerificationCode(
						values,
					);
					if (response.success) {
						setShowPasswordFields(true); // Show the password fields if verification is successful
						setLoadingVerify(false); // Set loading state to false to hide spinner on verify button
					} else {
						SendaCustomSwal.fire({
							title: "Código inválido",
							text: "O código de verificação é inválido.",
							iconHtml: '<i class="error-icon"></i>',
							customClass: {
								confirmButton: "custom-confirm-button",
							},
						});
					}
				} else {
					setLoadingSubmit(true); // Set loading state to true to show spinner on submit button
					// If password fields are required, submit the form
					const response = await userService.putNovaSenha(values);
					//close no modal
					toggle();
					setLoadingSubmit(false); // Set loading state to false to hide spinner on submit button
					// history.push('/login');
					SendaCustomSwal.fire({
						title: "Sucesso",
						text: "Sua senha foi alterada com sucesso.",
						iconHtml: '<i class="success-icon"></i>',
						customClass: {
							confirmButton: "custom-confirm-button",
						},
					});
				}
			} catch (error) {
				setLoadingVerify(false); // Set loading state to false to hide spinner on verify button
				setLoadingSubmit(false); // Set loading state to false to hide spinner on submit button
				SendaCustomSwal.fire({
					title: "Erro",
					text: "Ocorreu um erro ao verificar o código.",
					iconHtml: '<i class="error-icon"></i>',
					customClass: {
						confirmButton: "custom-confirm-button",
					},
				});
				console.log(error.message);
			}
		},
	});

	const { registrationError, loading } = useSelector((state) => ({
		registrationError: state.Account.registrationError,
		loading: state.Account.loading,
	}));

	useEffect(() => {
		dispatch(apiError(""));
	}, []);

	return (
		<React.Fragment>
			<div>
				<Container>
					<Row className="justify-content-center">
						<Col md={12} lg={12} xl={12}>
							<Card>
								<CardBody>
									<div>
										<Form
											className="form-horizontal"
											onSubmit={(e) => {
												e.preventDefault();
												validation.handleSubmit();
												return false;
											}}
										>
											{registrationError &&
											registrationError ? (
												<Alert color="danger">
													{registrationError}
												</Alert>
											) : null}

											{!showPasswordFields ? (
												// Show the verification code field
												<>
													<div className="mb-3">
														<Label className="form-label">
															Codigo de
															verificação
														</Label>
														<Input
															name="verification_code"
															type="text"
															placeholder="Insira o código de verificação"
															onChange={
																validation.handleChange
															}
															onBlur={
																validation.handleBlur
															}
															value={
																validation
																	.values
																	.verification_code ||
																""
															}
															invalid={
																validation
																	.touched
																	.verification_code &&
																validation
																	.errors
																	.verification_code
															}
														/>
														{validation.touched
															.verification_code &&
														validation.errors
															.verification_code ? (
															<FormFeedback type="invalid">
																{
																	validation
																		.errors
																		.verification_code
																}
															</FormFeedback>
														) : null}
													</div>
													<div className="mt-3 d-grid">
														<Button
															style={{
																background: "none",
																padding: 10,
																cursor: "pointer",
																color: "black",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
															}}
															type="submit"
															disabled={
																loadingVerify
															}
														>
															{loadingVerify ? (
																<span
																	className="spinner-border spinner-border-sm mr-1"
																	style={{
																		marginRight: 10,
																	}}
																></span>
															) : null}
															Verificar
														</Button>
													</div>
												</>
											) : (
												// Show the password fields
												<>
													<div className="mb-3">
														<Label className="form-label">
															Nova senha
														</Label>
														<Input
															name="new_password"
															type="password"
															placeholder="Digite a nova senha"
															onChange={
																validation.handleChange
															}
															onBlur={
																validation.handleBlur
															}
															value={
																validation
																	.values
																	.new_password ||
																""
															}
															invalid={
																validation
																	.touched
																	.new_password &&
																validation
																	.errors
																	.new_password
															}
														/>
														{validation.touched
															.new_password &&
														validation.errors
															.new_password ? (
															<FormFeedback type="invalid">
																{
																	validation
																		.errors
																		.new_password
																}
															</FormFeedback>
														) : null}
													</div>

													<div className="mb-3">
														<Label className="form-label">
															Confirme a nova
															senha
														</Label>
														<Input
															name="confirm_password"
															type="password"
															placeholder="Confirme a nova senha"
															onChange={
																validation.handleChange
															}
															onBlur={
																validation.handleBlur
															}
															value={
																validation
																	.values
																	.confirm_password ||
																""
															}
															invalid={
																validation
																	.touched
																	.confirm_password &&
																validation
																	.errors
																	.confirm_password
															}
														/>
														{validation.touched
															.confirm_password &&
														validation.errors
															.confirm_password ? (
															<FormFeedback type="invalid">
																{
																	validation
																		.errors
																		.confirm_password
																}
															</FormFeedback>
														) : null}
													</div>
													<div className="mt-3 d-grid">
														<Button
															style={{
																background: "none",
																padding: 10,
																cursor: "pointer",
																color: "black",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
															}}
															type="submit"
															disabled={
																loadingSubmit
															}
														>
															{loadingSubmit ? (
																<span
																	className="spinner-border spinner-border-sm mr-1"
																	style={{
																		marginRight: 10,
																	}}
																></span>
															) : null}
															Salvar
														</Button>
													</div>
												</>
											)}
										</Form>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default NovaSenha;
